import DAO from './DAO.js';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';
import _ from 'lodash';

export default class UserBuildAssignmentsDAO extends DAO {

  constructor(store) {
    super(store, 'user_build_assignment');
    this.unsetUserBuildAssignments = this.unsetUserBuildAssignments.bind(this);
    this.clearUserBuildAssignments = this.clearUserBuildAssignments.bind(this);
  }

  unsetUserBuildAssignments(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearUserBuildAssignments() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_user_build_assignments, options.toIgnore.userBuildAssignments, this.unsetUserBuildAssignments, this.clearUserBuildAssignments, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/UserBuildAssignmentsDAO.js